import { useState } from 'react';
import { AlertFilled } from 'iglooicon';
import { OtpVerification } from './otp-verification';
import './index.less';

export default (platformKey: string, currentEmail: string) => {
  const [email, setEmail] = useState<string>(currentEmail);
  const [emailVerifiSuccess, setEmailVerifiSuccess] = useState<boolean>(true);

  // 后端验证email，如果有错误信息则返回error message并显示
  // const emailExtra = emailVerifiSuccess
  //   ? ''
  //   : 'error message';

  const emailSuffix = emailVerifiSuccess ? undefined : (
    <AlertFilled className="errorSuffixIcon" />
  );

  const otpCodeExtraLabel = (
    <OtpVerification
      email={email}
      // verifiSuccess={emailVerifiSuccess}
      // setVerifiSuccess={setEmailVerifiSuccess}
      platformKey={platformKey}
    />
  );

  const onEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setEmailVerifiSuccess(true);
    setEmail(e?.target?.value?.trim() || '');
  };

  return {
    // email,
    // setEmail,
    emailVerifiSuccess,
    setEmailVerifiSuccess,
    // emailExtra,
    emailSuffix,
    otpCodeExtraLabel,
    onEmailChange,
  };
};
